export const COLOR_AI_GRADIENT_START = '#7e25c4';
export const COLOR_AI_GRADIENT_END = '#f50182';
export const AI_CLASSIFICATION_GRADIENT = `linear-gradient(to right, ${COLOR_AI_GRADIENT_START}, ${COLOR_AI_GRADIENT_END})`;
